var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_21098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0438 5.48132C12.2563 5.48132 8.31878 6.29382 5.05003 8.26883C-1.85622 12.4376 -1.04372 21.5501 3.66878 27.1001C5.47503 29.2251 9.89378 33.2438 13.0438 31.5313C15.2438 30.3376 14.3188 28.6188 13.9375 27.3376C13.7125 26.5688 14.2875 25.8001 15.0875 25.8063C15.0938 25.8063 15.1 25.8063 15.1063 25.8063C23.9188 25.8063 31.9938 21.2063 31.9938 15.6126C31.9938 10.0188 24.8563 5.48132 16.0438 5.48132Z",
    fill: "#D28E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10625 25.8625C8.58016 25.8625 9.775 24.6677 9.775 23.1938C9.775 21.7199 8.58016 20.525 7.10625 20.525C5.63234 20.525 4.4375 21.7199 4.4375 23.1938C4.4375 24.6677 5.63234 25.8625 7.10625 25.8625Z",
    fill: "#FFCC4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6563 18C7.13021 18 8.32505 16.8051 8.32505 15.3312C8.32505 13.8573 7.13021 12.6625 5.6563 12.6625C4.18239 12.6625 2.98755 13.8573 2.98755 15.3312C2.98755 16.8051 4.18239 18 5.6563 18Z",
    fill: "#43C6B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.15 13.9625C14.6239 13.9625 15.8187 12.7677 15.8187 11.2937C15.8187 9.81984 14.6239 8.625 13.15 8.625C11.676 8.625 10.4812 9.81984 10.4812 11.2937C10.4812 12.7677 11.676 13.9625 13.15 13.9625Z",
    fill: "#E16464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4874 13.3313C22.9613 13.3313 24.1561 12.1364 24.1561 10.6625C24.1561 9.18862 22.9613 7.99377 21.4874 7.99377C20.0134 7.99377 18.8186 9.18862 18.8186 10.6625C18.8186 12.1364 20.0134 13.3313 21.4874 13.3313Z",
    fill: "#50C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8627 9.55L24.6564 8.625L22.4564 9.55625C22.4564 9.55625 22.2564 12.8625 23.5189 16.2125L24.6564 17.6562L25.7939 16.2125C27.0627 12.8562 26.8627 9.55 26.8627 9.55Z",
    fill: "#E7EEF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8001 16.2062C27.5626 20.6749 26.9064 31.4499 24.6626 31.4499C22.4188 31.4499 21.7626 20.6749 23.5251 16.2062H25.8001Z",
    fill: "#50C4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0437 3.35005C26.1062 2.3938 25.6062 1.45005 25.3312 0.718796C25.0812 0.0437956 24.325 -0.162454 23.8187 0.312546C22.7187 1.3438 21.225 3.27505 21.075 6.28129C21.0062 7.5813 21.4625 8.51254 22.0625 9.17505C23.3812 10.6375 25.5 10.7438 26.9562 9.42505C27.6187 8.82504 28.1687 7.9438 28.2375 6.6438C28.2375 6.63755 28.2375 6.62505 28.2375 6.61879C28.3 5.3813 27.8562 4.1813 27.0437 3.35005Z",
    fill: "#3A484A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_21098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.c725d2725f79594fed722b11c420be2e.svg";
export { ForwardRef as ReactComponent };